import { Heading } from "@aprendaagora/simple-react-component-library";
import React from "react";

const AtomsPage = () => {
  return (
    <div>
      <Heading text="Atoms" tailwind="mb-3" />

      <p className="p-3 border">
        The atoms of our interfaces serve as the foundational building blocks
        that comprise all our user interfaces. These atoms include basic HTML
        elements like form labels, inputs, buttons, and others that can’t be
        broken down any further without ceasing to be functional.
      </p>
    </div>
  );
};

export default AtomsPage;
